<template>
  <div>
    <el-table
      border
      :data="mediaList.data"
      :row-key="mediaRowKey"
      :expand-row-keys="expandRowKeysMedia"
      style="width: 100%"
      class="tables"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" label-width="100px" inline class="demo-table-expand">
            <el-form-item label="报道标题">
              <span>{{props.row.title}}</span>
            </el-form-item>
            <el-form-item label="报道级别">
              <span>{{ props.row.level_text }}</span>
            </el-form-item>
            <el-form-item label="报道类型">
              <span>{{ props.row.type_text }}</span>
            </el-form-item>

            <el-form-item label="链接地址">
              <span v-if="props.row.url">
                <a
                  :href="props.row.url?props.row.url:'javascript:;'"
                  target="_blank"
                  style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                >{{ props.row.url }}</a>
              </span>
            </el-form-item>
            <el-form-item label="附件">
              <!-- <span
                @click="downFile(props.row.file, props.row.file_name)"
                style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
              >{{ props.row.file_name }}</span> -->
              <a
                :href="props.row.file_url"
                target="_blank"
              >{{props.row.file_name}}</a>
            </el-form-item>
            <el-form-item label="报道说明">
              <span>{{ props.row.description }}</span>
            </el-form-item>
            <el-form-item label="报道图片">
              <viewer :images="props.row.pic_url" v-if="props.row.pic_url.length>0">
                <img
                  v-for="value in props.row.pic_url"
                  :src="value"
                  :key="value"
                  style="width: 50px; height: 50px;cursor: pointer;margin-right:5px"
                />
                <p style="clear: both; padding-top: 10px">
                  <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击上方图片查看/下载大图
                </p>
              </viewer>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="媒体报道标题" min-width="220" align="center" prop="title"></el-table-column>
      <el-table-column label="报道级别" width="160" align="center" prop="level_text"></el-table-column>
      <el-table-column label="添加时间" width="200" align="center" prop="addtime"></el-table-column>
    </el-table>
    <div>
      <el-pagination
        :total="mediaList.total"
        :current-page.sync="mediaList.current_page"
        background
        layout="prev, pager, next"
        :page-size="15"
        hide-on-single-page
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      mediaList: {
        total: 0,
        current_page: 1
      }, //媒体报道列表
      expandRowKeysMedia: []
    };
  },
  methods: {
    //媒体报道展开
    mediaRowKey(row) {
      return row.id;
    },

    //点击页码
    handlePageChange(page) {
      this.getMediaList(page);
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //媒体报告列表
    getMediaList(page = 1) {
      //这里的project_type 2 表示众筹项目
      this.$db
        .post(this.$db.config.mediaCoverageList, {
          project_id: this.id,
          project_type: 2,
          page: page
        })
        .then(res => {
          if (res && res.code == 200) {
            this.mediaList = res.data;
            if (res.data.data && res.data.data.length > 0) {
              this.expandRowKeysMedia.push(this.mediaList.data[0].id);
            }
          }
        });
    }
  },
  mounted() {
    this.getMediaList();
  }
};
</script>

<style>
.tables /deep/ .el-form--inline .el-form-item__label {
  color: #99a9bf;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand-lable {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 48%;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/detail_media.vue